import { Box, CardMedia, Typography } from '@mui/material'
import { format } from 'date-fns'
import React from 'react'

const TIME_SLOT_HOUR_LABEL = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
]
const TIME_SLOT_HEIGHT = 100

const SchedulerGrid = ({
  events,
  selectedEvent,
  setSelectedEvent,
  currentWeekStartDate,
  setCurrentDate,
  interviewData,
  isEdit,
}) => {
  const getWeekDates = (startOfWeek) => {
    const daysOfWeek = []
    for (let i = 0; i < 7; i++) {
      const date = new Date(startOfWeek)
      date.setDate(startOfWeek.getDate() + i)
      daysOfWeek.push(date)
    }
    return daysOfWeek
  }

  const handleSelect = (date, start, duration) => {
    setSelectedEvent({
      date,
      start,
      end: start + duration,
    })
    setCurrentDate(date)
  }

  const calcEventHeight = (start, end) => {
    return (end - start) * TIME_SLOT_HEIGHT
  }

  const calcEventStartPoint = (start) => {
    if (!Number.isInteger(start)) {
      return (start - Math.floor(start)) * TIME_SLOT_HEIGHT
    } else return 0
  }

  const currentWeekDates = getWeekDates(currentWeekStartDate)

  const candidateDetails = isEdit
    ? interviewData?.relations?.jobAdCandidate?.relations?.candidateable
    : null

  return (
    <Box sx={{ display: 'flex' }}>
      <Box>
        <Typography
          sx={{
            width: '60px',
            padding: '8px',
            borderBottom: '1px solid #EDEFF0',
            backgroundColor: 'default-background.main',
            color: 'transparent',
          }}
        >
          Time
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          width: '100%',
          gridTemplateColumns: 'repeat(7, 1fr)',
        }}
      >
        {currentWeekDates.map((date, dateIndex) => (
          <Box key={dateIndex}>
            <Typography
              sx={{
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #EDEFF0',
                borderLeft: '1px solid #EDEFF0',
                backgroundColor: 'default-background.main',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {format(date, 'EEE, dd/MM')}
            </Typography>
            {TIME_SLOT_HOUR_LABEL.map((_, hourIndex) => (
              <Box key={hourIndex} sx={{ position: 'relative' }}>
                {dateIndex === 0 && (
                  <Box
                    style={{
                      width: '45px',
                      position: 'absolute',
                      right: '100%',
                      bottom: -10,
                      color: 'light-gray-text.main',

                      display: hourIndex === TIME_SLOT_HOUR_LABEL.length - 1 ? 'none' : '',
                    }}
                  >
                    {hourIndex + 1 > 12 ? hourIndex - 11 : hourIndex + 1}{' '}
                    {hourIndex + 1 > 11 ? 'PM' : 'AM'}
                  </Box>
                )}
                <Box
                  key={hourIndex}
                  sx={{
                    position: 'relative',
                    width: '100%',
                    paddingX: '8px',
                    borderTop: hourIndex === 0 ? 'none' : '1px solid #EDEFF0',
                    borderLeft: '1px solid #EDEFF0',
                    paddingBottom: hourIndex === TIME_SLOT_HOUR_LABEL.length - 1 ? '1px' : 0,
                  }}
                >
                  <Box
                    sx={{
                      height: '64px',
                      display: 'flex',
                      position: 'relative',
                      zIndex: 1,
                      borderRadius: '2.5px',
                      '&:hover': {
                        backgroundColor: 'alternate.light',
                        outline: '1px solid #09A3A9',
                      },
                    }}
                    onClick={() => handleSelect(date, hourIndex + 1, 1)}
                  >
                    {selectedEvent.date &&
                      format(selectedEvent.date, 'EEE, dd/MM') === format(date, 'EEE, dd/MM') &&
                      Math.floor(selectedEvent.start) === hourIndex + 1 && (
                        <Box
                          style={{
                            height: `${calcEventHeight(selectedEvent.start, selectedEvent.end)}%`,
                            top: `${calcEventStartPoint(selectedEvent.start)}%`,
                          }}
                          sx={{
                            position: 'absolute',
                            backgroundColor: 'alternate.light',
                            borderRadius: '2.5px',
                            width: '100%',
                            outline: '1px solid #09A3A9',
                            padding: isEdit ? '6px' : '8px',
                            display: 'flex',
                            gap: '4px',
                          }}
                        >
                          {isEdit && (
                            <Box>
                              {candidateDetails?.profile_image_url ? (
                                <CardMedia
                                  component="img"
                                  sx={{
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '100%',
                                    objectFit: 'cover',
                                  }}
                                  src={candidateDetails?.profile_image_url}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '100%',
                                    backgroundColor: 'alternate.main',
                                    color: 'white.main',
                                    textTransform: 'capitalize',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '10px',
                                  }}
                                >
                                  {candidateDetails?.name.charAt(0)}
                                </Box>
                              )}
                            </Box>
                          )}
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: 'alternate.main',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {isEdit ? interviewData?.title : '+ New interview'}
                          </Typography>
                        </Box>
                      )}
                    {events.length > 0 &&
                      events.map(
                        (event, eventIndex) =>
                          format(event.date, 'EEE, dd/MM') === format(date, 'EEE, dd/MM') &&
                          Math.floor(event.start) === hourIndex + 1 && (
                            <Box
                              key={eventIndex}
                              style={{
                                height: `${calcEventHeight(event.start, event.end)}%`,
                                top: `${calcEventStartPoint(event.start)}%`,
                              }}
                              sx={{
                                position: 'absolute',
                                width: '100%',
                                backgroundColor: 'default-background.main',
                                borderRadius: '2.5px',
                                padding: '6px',
                                display: 'flex',
                                gap: '4px',
                                zIndex: -1,
                              }}
                            >
                              {event.candidate_image_url ? (
                                <Box>
                                  <CardMedia
                                    component="img"
                                    sx={{
                                      width: '16px',
                                      height: '16px',
                                      borderRadius: '100%',
                                      objectFit: 'cover',
                                    }}
                                    src={event.candidate_image_url}
                                  />
                                </Box>
                              ) : (
                                <Box>
                                  <Box
                                    sx={{
                                      width: '16px',
                                      height: '16px',
                                      borderRadius: '100%',
                                      backgroundColor: 'alternate.main',
                                      color: 'white.main',
                                      textTransform: 'capitalize',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      fontSize: '10px',
                                    }}
                                  >
                                    {event.candidate_name.charAt(0)}
                                  </Box>
                                </Box>
                              )}
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {event.title}
                              </Typography>
                            </Box>
                          )
                      )}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default SchedulerGrid
